/**
 * Webhooks API - Complete implementation
 */

import { Webhook } from '../types/api';
import { getAPIClient } from './client';

export async function listWebhooks(projectId: string): Promise<Webhook[]> {
  const client = getAPIClient();
  return client.get<Webhook[]>('/webhooks', {
    params: { project_id: projectId },
  });
}

export async function getWebhooks(projectId: string): Promise<Webhook[]> {
  return listWebhooks(projectId);
}

export async function createWebhook(data: {
  project_id: string;
  callback_url: string;
  event_types: string[];
  secret?: string;
}): Promise<Webhook> {
  const client = getAPIClient();
  return client.post<Webhook>('/webhooks', data);
}

export async function deleteWebhook(webhookId: string): Promise<void> {
  const client = getAPIClient();
  return client.delete(`/webhooks/${webhookId}`);
}

export async function testWebhook(webhookId: string): Promise<{ success: boolean; message: string }> {
  const client = getAPIClient();
  return client.post(`/webhooks/${webhookId}/test`);
}
